import "./whirl.css";

export const Spinner = {
	CLASS: "whirl",

	hide: (element: HTMLElement) => {
		element.classList.remove(Spinner.CLASS);
	},

	parentElement: (item: HTMLElement | null, className?: string): HTMLElement | null => {
		let el = item && item.parentElement;
		if (className) {
			while (el && !el.classList.contains(className)) {
				el = el.parentElement;
			}
			return el;
		} else if (el) {
			return el.parentElement;
		}
		return null;
	},

	show: (element: HTMLElement, spinner?: string): (() => void) => {
		element.classList.add(Spinner.CLASS);
		element.classList.add(spinner || "traditional");
		return () => Spinner.hide(element);
	},
};

/*

export default class Spinner {
	tableElement: any = undefined;
	isSet = false;

	public refresh(element: any) {
		if (this.isSet) {
			if (!this.tableElement)
				this.show(element);
		}
		else
			this.hide();
	}

	public show(element: any | null | undefined) {
		this.isSet = true;
		if (!this.tableElement && element) {
			const spinner = 'traditional';
			const self = this;
			this.tableElement = element;
			this.tableElement.classList.add('whirl');
			const _spinner = spinner.split(' ');
			_spinner.forEach(function (s) {
				self.tableElement.classList.add(s);
			});
		}
	}

	public hide() {
		this.isSet = false;
		if (this.tableElement) {
			this.tableElement.classList.remove('whirl');
			this.tableElement = undefined;
		}
	}
}
*/
